import { CustomerAccountChangeMobileEquipmentProps } from '../types';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatIconChevronRight } from '@blocks-react/components/Icons/ChevronRight';
export const CustomerAccountChangeMobileEquipment = ({
  children
}: CustomerAccountChangeMobileEquipmentProps) => {
  
  return (
    <div className="d-flex align-items-center justify-content-between py-2 my-1 px-3">
      <CatHeading variant="label-sm">{children}</CatHeading>
      <CatIconChevronRight size="sm" slot="after" className="u-color--Black" />
    </div>
  );
};
